<template>
  <div>
    <van-sticky>
      <nav-bar class="home-nav">
        <div slot="left" @click="onClickLeft">返回</div>
        <div slot="center">免测申请</div>
      </nav-bar>
    </van-sticky>
    <div class="content">
      <div class="download">
        <h1>下载免测申请</h1>
        <span>免测申请表<van-icon name="down" size="20" color="#1989fa"/></span>
      </div>
      <div class="check">
        <h1>学部审核</h1>
        <span>辅导员审核并签字</span>
        <span>学部主管学生工作书记审核并签字</span>
      </div>
      <div class="upload">
        <h1>上传资料</h1>
        <span>上传免测申请表(学部签字)

        </span>
        <span>上传医院诊断证明(印章清晰)
        <van-uploader v-if="passed===0" style="white-space:nowrap;" v-model="fileList" :max-count="2"
                      :before-read="before_read"
                      :after-read="after_read" :before-delete="delete_file">
         <van-icon name="add" size="30px" color="#1989fa"/>共两张
        </van-uploader>
        </span>
        <van-button v-show="fileList.length>=2" @click="submit"><span style="color: #1989fa">点击提交</span></van-button>
      </div>
      <div class="result">
        <h1>当前审核状态</h1>
        <span v-if="passed==0" style="color: #0570db">暂未申请</span>
        <span v-if="passed==1" style="color: #0570db">审核中</span>
        <span v-if="passed==2" style="color: red">免测原因不符合政策要求,请正常参加体侧</span>
        <span v-if="passed==3">申请通过,请在三个工作日内上交免测申请 <span style="color: #0570db">纸质版</span> (体侧健康测试中心办公室)</span>
      </div>
    </div>
  </div>
</template>

<script>
import {getToken, upLoadImageToQiNiu} from "../../../network/upLoader";
import {StuAddNoTest, StuGetNoTestInfo} from "../../../network/no_test";
import NavBar from "components/common/navbar/NavBar";
import Vue from 'vue';
import {Dialog, Icon, Sticky, Uploader, Button, Toast} from 'vant';

Vue.use(Icon);
Vue.use(Sticky);
Vue.use(Uploader);
Vue.use(Button);
export default {
  name: "NoTestApply",
  components: {
    NavBar
  },
  data() {
    return {
      //image file
      fileList: [],
      img1: "1",
      img2: "1",
      index: 0,
      //
      passed: 0,

    }
  },
  activated() {
    StuGetNoTestInfo().then(res => {
      if (!res.status) {
        this.passed = 0;
      } else if (res.info.passed == 1) {
        this.passed = 1;
      } else if (res.info.passed == 2) {
        this.passed = 2;
      } else if (res.info.passed == 3) {
        this.passed = 3;
      }
    })
  },
  methods: {
    onClickLeft() {
      this.$router.replace("/home");
    },
    before_read(file) {
      let fileTypes = file.name.split('.');
      let fileType = fileTypes[fileTypes.length - 1];
      if (fileType !== 'jpg' && fileType !== 'jpeg' && fileType !== 'png') {
        Dialog.alert({
          message: '请上传 jpg,jpeg,jpeg 格式文件',
        });
        return false;
      } else if (file.size > 10039264) {
        Dialog.alert({
          message: '文件过大,请保持在10M以内',
        });
        return false;
      }
      return true;
    },
    after_read(file) {
    },
    delete_file() {
      this.fileList = [];
      return true;
    },
    submit() {
      getToken().then(token => {
        for (let i = 0; i < 2; i++) {
          this.fileList[i].status = 'uploading';
          this.fileList[i].message = '上传中...';
          let data = new FormData();
          data.append('token', token);
          data.append("file", this.fileList[i].file);
          upLoadImageToQiNiu(data).then(data => {
            if (i === 0 || i === '0') {
              this.img1 = 'http://cdn.sport.hhstu.club/' + data.data.key;
            } else if (i === 1 || i === '1') {
              this.img2 = 'http://cdn.sport.hhstu.club/' + data.data.key;
            }
            this.index++;
            if (this.index >= 2)
              this.upload();
            this.fileList[i].status = 'done';
            this.fileList[i].message = '提交成功';
          }).catch(function (err) {
            this.fileList[i].status = 'failed';
            this.fileList[i].message = '提交失败';
          });
        }
      })
    },
    upload() {
      console.log(this.img1);
      console.log(this.img2);
      StuAddNoTest(this.img1, this.img2).then(res => {
        if (res.status) {
          Dialog.alert({
            title: '提交成功',
            message: '审核过后，结果会在此页面下方显示。',
          }).then(() => {
            // on close
            location.reload();
          });

        } else {
          Dialog.alert({
            title: '提交失败',
            message: '请在我的->联系我们,及时联系工作人员处理',
          }).then(() => {
            // on close
            location.reload();
          });
        }
      })
    }
  }
}
</script>

<style scoped>
a {
  text-decoration: none;
}

/*@font-face {*/
/*  font-family: 'icomoon';*/
/*  src: url('../../../assets/fonts/icomoon.eot?7kkyc2');*/
/*  src: url('../../../assets/fonts/icomoon.eot?7kkyc2#iefix') format('embedded-opentype'),*/
/*  url('../../../assets/fonts/icomoon.ttf?7kkyc2') format('truetype'),*/
/*  url('../../../assets/fonts/icomoon.woff?7kkyc2') format('woff'),*/
/*  url('../../../assets/fonts/icomoon.svg?7kkyc2#icomoon') format('svg');*/
/*  font-weight: normal;*/
/*  font-style: normal;*/
/*}*/

@font-face {
  font-family: 'title';
}

.content {
  height: 100vh;
  background-color: #d5eaff;
}

.content {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
}

.content div {
  display: flex;
  flex-direction: column;
  width: 95%;
  height: 20%;
  border-radius: 6px;
  background-color: #fff;
}

.content .download span::after {
  font-family: 'icomoon';
  font-size: 25px;
  display: inline-block;
  color: #f50;
  margin-left: 10px;
  transform: translateY(4px);
}

.content div:first-child {
  height: 15%;
}

.content div:last-child {
  height: 27%;
}

.content div h1 {
  font-family: 'title';
  padding-left: 10px;
  color: #000;
  font-size: 18px;
}

.content div span {
  font-family: '宋体';
  font-size: 16px;
  color: #000;
  font-weight: bold;
  padding: 10px 0 10px 10px;
}

.content .upload {
  height: 30%;
}

.content .upload span::after {
  margin-left: 10px;
  font-family: 'icomoon';
  display: inline-block;
  font-size: 25px;
  color: green;

  transform: translateY(4px);
}

.content .result {
  padding-right: 5px;
}


</style>
